import { Api } from "../config/request";
export default {
  getIssueTypeList(body) {
    return Api.post(`/logistics_support/issue_types`, body);
  },
  getIssueArea() {
    return Api.get(`/logistics_support/issue_areas`);
  },
  getIssueDetail(issueId) {
    return Api.get(`/logistics_support/issue_types/${issueId}`);
  },
  saveUpdateIssueType(actionType, body) {
    if (actionType === "create") {
      return Api.post("/logistics_support/save_issue_type", body);
    } else {
      return Api.put("/logistics_support/update_issue_type", body);
    }
  },
  getIssueTypeRemoteSearch(startsWith) {
    return Api.get(
      `/logistics_support/issue_list_dropdown_data?startswith=${startsWith}`
    );
  },
};
